var path = '/app/pages/stage-seventh/stage-seventh.html';
var html = "<stage-book-puzzle class=fill type=\"'color'\" title={{$ctrl.title}} is-drop-valid=$ctrl.isDropValidBindded forms=$ctrl.forms dropzones=$ctrl.dropzones on-success=$ctrl.onSuccess() on-fail=$ctrl.onFail()> <stage-book-description> <h3 class=stage-book-category> <div>A Figura ao lado é formada <strong>Seis peças</strong> que você consquistou.</div> <div> Use cada uma delas para montar este quebra-cabeça e deixar seu álbum <br> mais bonito! </div> </h3> </stage-book-description> </stage-book-puzzle>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/stage-seventh/stage-seventh.html
// module id = 276
// module chunks = 0